<div
  class="attribute-editor-component folder-component-container"
  rvSpinner="loading-folder"
  [rvShowSpinner]="processing"
>
  <div class="folder-component-settings te-scrollable-container">
    <div class="attribute-editor-row">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            @if (!isGooglePhotosAlbum) {
              @if (shouldShowSummary) {
                <div class="folder-summary">
                  <div class="folder-summary-row">
                    @switch (summaryThumbnailKind) {
                      @case ('image') {
                        <div
                          class="folder-summary-image-thumb"
                          [class.loading]="thumbnailLoading"
                          [class.default-thumbnail]="
                            thumbnailUrl === defaultImageThumbnail
                          "
                        >
                          @if (thumbnailUrl) {
                            <img
                              [src]="thumbnailUrl"
                              [class.invisible]="thumbnailLoading"
                              alt=""
                              aria-hidden="true"
                              (load)="onThumbnailLoaded()"
                              (error)="onThumbnailLoaded()"
                            />
                          }
                        </div>
                      }
                      @case ('video') {
                        <div
                          class="folder-summary-image-thumb"
                          [class.loading]="thumbnailLoading"
                          [class.default-thumbnail]="
                            thumbnailUrl === defaultImageThumbnail
                          "
                        >
                          @if (thumbnailUrl) {
                            <img
                              [src]="thumbnailUrl"
                              [class.invisible]="thumbnailLoading"
                              alt=""
                              aria-hidden="true"
                              (load)="onThumbnailLoaded()"
                              (error)="onThumbnailLoaded()"
                            />
                          } @else if (videoPreviewUrl) {
                            <video
                              preload="metadata"
                              muted
                              [class.invisible]="thumbnailLoading"
                              aria-hidden="true"
                              (loadeddata)="onThumbnailLoaded()"
                              (error)="onThumbnailLoaded()"
                            >
                              <source [src]="videoPreviewUrl" />
                            </video>
                          }
                          @if (thumbnailUrl !== defaultImageThumbnail) {
                            <mat-icon
                              svgIcon="play-circle-filled"
                              class="folder-summary-play"
                            ></mat-icon>
                          }
                        </div>
                      }
                      @case ('folder') {
                        @if (folderTopThumbnailUrl === defaultImageThumbnail) {
                          <div
                            class="folder-summary-image-thumb default-thumbnail"
                          >
                            <img
                              [src]="folderTopThumbnailUrl"
                              alt=""
                              aria-hidden="true"
                            />
                          </div>
                        } @else {
                          <div
                            class="folder-summary-stack-thumb"
                            [class.loading]="thumbnailLoading"
                          >
                            <div class="folder-summary-stack-back"></div>
                            <div class="folder-summary-stack-middle"></div>
                            <div class="folder-summary-stack-top">
                              @if (folderTopThumbnailUrl && folderTopIsVideo) {
                                <video
                                  preload="metadata"
                                  muted
                                  [class.invisible]="thumbnailLoading"
                                  aria-hidden="true"
                                  (loadeddata)="onThumbnailLoaded()"
                                  (error)="onThumbnailLoaded()"
                                >
                                  <source [src]="folderTopThumbnailUrl" />
                                </video>
                              } @else if (folderTopThumbnailUrl) {
                                <img
                                  [src]="folderTopThumbnailUrl"
                                  [class.invisible]="thumbnailLoading"
                                  alt=""
                                  aria-hidden="true"
                                  (load)="onThumbnailLoaded()"
                                  (error)="onThumbnailLoaded()"
                                />
                              }
                            </div>
                          </div>
                        }
                      }
                    }
                    <div class="folder-summary-details">
                      <div class="folder-summary-name" title="{{ folderPath }}">
                        {{ summaryName }}
                      </div>
                      <div class="folder-summary-subtitle">
                        {{ summarySubtitle }}
                      </div>
                    </div>
                  </div>
                  <button
                    rv-button
                    variant="secondary"
                    type="button"
                    id="folder-component-replace"
                    (click)="selectMedia()"
                  >
                    {{ summaryReplaceLabel }}
                  </button>
                </div>
              } @else {
                <div class="flex-row flex-wrap space-between mb-3">
                  @if (isDocument) {
                    <span>
                      <span title="{{ folderPath }}">
                        <strong>{{ folderName }}</strong
                        ><br />
                        <em>{{
                          values.assetFiles ? values.assetFiles + ' pages' : ''
                        }}</em>
                      </span>
                    </span>
                  } @else {
                    <span>
                      {{ typeName }}
                      <span
                        title="{{ folderPath }}"
                        [shown]="!isGooglePhotosAlbum"
                      >
                        — {{ folderName }}</span
                      >
                    </span>
                  }
                  @if (storageManagerService.isCanva(values.source)) {
                    <div class="canva-component-alert">
                      <div class="canva-alert-title">
                        Canva Component Update
                      </div>
                      <div class="canva-alert-message">
                        You're using an older Canva component that can't be
                        edited anymore. Add the new Canva component to make
                        changes or update your design.
                      </div>
                    </div>
                  } @else {
                    <a
                      rv-link
                      tabindex="0"
                      id="folder-component-source"
                      (click)="selectMedia()"
                      (keyup.enter)="selectMedia()"
                      >Edit</a
                    >
                  }
                </div>
              }
            }
            @if (showSizingControl) {
              <div class="layout-selector image-display-selector">
                <div class="image-display-heading">
                  <p
                    id="folder-image-display-label"
                    class="image-display-title"
                  >
                    Image display
                  </p>
                  <p class="image-display-description">
                    Choose how the image fits within the frame.
                  </p>
                </div>
                <div
                  class="layout-container"
                  role="radiogroup"
                  aria-labelledby="folder-image-display-label"
                >
                  <button
                    #sizingOptionBtn
                    type="button"
                    id="folder-image-display-fill"
                    class="layout-option image-display-option image-display-option--fill"
                    [ngClass]="{
                      'layout-option--selected': values.sizing === SIZING_FILL,
                    }"
                    (click)="setSizing(SIZING_FILL)"
                    (keydown)="onSizingKeydown($event, SIZING_FILL)"
                    [attr.aria-checked]="values.sizing === SIZING_FILL"
                    [attr.tabindex]="values.sizing === SIZING_FILL ? 0 : -1"
                    role="radio"
                  >
                    <div class="image-display-preview">
                      <div class="image-display-frame">
                        <div class="image-display-photo"></div>
                        <div
                          class="image-display-handle image-display-handle--tl"
                        ></div>
                        <div
                          class="image-display-handle image-display-handle--tr"
                        ></div>
                        <div
                          class="image-display-handle image-display-handle--br"
                        ></div>
                        <div
                          class="image-display-handle image-display-handle--bl"
                        ></div>
                      </div>
                    </div>
                    <div class="layout-label">Fill</div>
                  </button>

                  <button
                    #sizingOptionBtn
                    type="button"
                    id="folder-image-display-fit"
                    class="layout-option image-display-option image-display-option--fit"
                    [ngClass]="{
                      'layout-option--selected': values.sizing === SIZING_FIT,
                    }"
                    (click)="setSizing(SIZING_FIT)"
                    (keydown)="onSizingKeydown($event, SIZING_FIT)"
                    [attr.aria-checked]="values.sizing === SIZING_FIT"
                    [attr.tabindex]="values.sizing === SIZING_FIT ? 0 : -1"
                    role="radio"
                  >
                    <div class="image-display-preview">
                      <div class="image-display-frame">
                        <div class="image-display-photo-window">
                          <div
                            class="image-display-photo image-display-photo--fit"
                          ></div>
                        </div>
                        <div
                          class="image-display-handle image-display-handle--tl"
                        ></div>
                        <div
                          class="image-display-handle image-display-handle--tr"
                        ></div>
                        <div
                          class="image-display-handle image-display-handle--br"
                        ></div>
                        <div
                          class="image-display-handle image-display-handle--bl"
                        ></div>
                      </div>
                    </div>
                    <div class="layout-label">Fit</div>
                  </button>
                </div>
              </div>
            }
            @if (values.fileMissing) {
              <div class="panel tw-mt-4">
                <div class="panel-body bg-warning">
                  <i aria-hidden="true" class="fa fa-warning icon-left"></i>
                  <span [shown]="values.type === 'storage-file'">
                    This file cannot be displayed properly because it does not
                    exist in storage (it may have been moved, renamed or
                    deleted). Please select a new file.
                  </span>
                  <span [shown]="values.type === 'storage-folder'">
                    This folder is either empty, or it has been moved, renamed
                    or deleted. Please select a new file or folder.
                  </span>
                </div>
              </div>
            } @else if (conversionError) {
              <div class="panel mt-4">
                <div class="panel-body bg-warning">
                  <i aria-hidden="true" class="fa fa-warning icon-left"></i>
                  <span>
                    The file could not be converted for use in the playlist.<br />
                    {{ conversionError }}
                  </span>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    @if (isGooglePhotosAlbum) {
      <div class="attribute-editor-row">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <div class="has-error">
                <div>
                  <p class="help-block mt-1 font-weight-bold">
                    The Google Photos feature is no longer available.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <div [hidden]="isGooglePhotosAlbum">
      <div
        class="attribute-editor-row folder-component-list-duration"
        [hidden]="values.type === 'storage-file' && !isDocument"
      >
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>Show each {{ isDocument ? 'page' : 'image' }} for:</label>
              <div class="input-group">
                <input
                  type="number"
                  id="folder-component-duration"
                  class="form-control"
                  [(ngModel)]="values.duration"
                  (change)="saveDuration()"
                />
                <span class="input-group-addon">Seconds</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="attribute-editor-row"
        [hidden]="fileType === 'image' || isDocument"
      >
        <div id="folder-component-volume">
          <label>Video volume:</label>
          <div class="w-100 flex flex-row gap-3">
            <mat-icon svgIcon="volume" class="mr-1 large"></mat-icon>
            <mat-slider
              min="0"
              max="100"
              step="1"
              color="accent"
              aria-label="Video volume control"
              class="flex-grow"
            >
              <input
                matSliderThumb
                [(ngModel)]="values.volume"
                (valueChange)="saveVolume()"
                [attr.aria-valuetext]="values.volume + ' percent volume'"
              />
            </mat-slider>
            <div class="volume">{{ values.volume }}</div>
          </div>
        </div>
      </div>
      <div class="attribute-editor-row" [shown]="isVideo">
        <div class="row pt-3">
          <div class="col-xs-12">
            <div class="flex-row flex-wrap space-between">
              <label>Video Subtitles (.srt, .vtt):</label>
              <button
                rv-button
                variant="secondary"
                [shown]="!values.subtitlesSource"
                type="button"
                id="te-add-subtitles"
                name="te-add-subtitles"
                (click)="addSubtitles()"
              >
                <mat-icon svgIcon="add" aria-hidden="true"></mat-icon>
                Add Subtitles
              </button>
            </div>
          </div>
        </div>
        <div class="row" [shown]="values.subtitlesSource">
          <div class="col-xs-12">
            <div class="form-group tw-mb-2.5">
              <div class="flex-row flex-wrap space-between">
                <span
                  class="subtitles-filename"
                  title="{{ values.subtitlesSource | filename }}"
                  >{{ values.subtitlesSource | filename }}</span
                >
                <button
                  mat-icon-button
                  (click)="deleteSubtitles()"
                  aria-label="Delete subtitles"
                  class="delete-subtitles mdc-icon-button mat-mdc-icon-button"
                >
                  <mat-icon svgIcon="trash"></mat-icon>
                </button>
              </div>
              @if (values.subtitlesFileMissing) {
                <div class="panel tw-mt-2">
                  <div class="panel-body bg-warning">
                    <i aria-hidden="true" class="fa fa-warning icon-left"></i>
                    <span>
                      This file cannot be displayed properly because it does not
                      exist in storage (it may have been moved, renamed or
                      deleted). Please select a new file.
                    </span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="attribute-editor-row" [shown]="values.subtitlesSource">
        <div class="flex-row left-right-aligner pt-3">
          <label id="folder-center-subtitles-label" class="mb-0 control-label"
            >Center Subtitles:</label
          >
          <mat-slide-toggle
            class="pl-3"
            [checked]="values.centerSubtitles"
            (change)="centerSubtitlesChanged($event.checked)"
            [attr.aria-labelledby]="'folder-center-subtitles-label'"
          ></mat-slide-toggle>
        </div>
      </div>
      <div
        class="attribute-editor-row"
        [hidden]="values.type === 'storage-file' && !isDocument"
      >
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label class="u_margin-sm-top"
                >Transition between folder items:</label
              >
              <select
                id="folder-component-transition"
                class="form-control"
                [(ngModel)]="values.transition"
                (change)="saveTransition()"
              >
                <option value="">No Transition</option>
                <option value="fadeIn">Fade In</option>
                <option value="slideFromLeft">Slide from left</option>
                <option value="slideFromRight">Slide from right</option>
                <option value="slideFromTop">Slide from top</option>
                <option value="slideFromBottom">Slide from bottom</option>
                <option value="zoomIn">Zoom in</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div
        class="attribute-editor-row"
        [shown]="values.type === 'storage-folder'"
      >
        <div class="form-group my-3">
          <div class="flex-row left-right-aligner">
            <label id="resume-label" class="mb-0"
              >Resume from last played</label
            >
            <mat-slide-toggle
              class="mb-2"
              id="resume-toggle"
              aria-labelledby="resume-label"
              [checked]="values.resume"
              (change)="toggleResume()"
            ></mat-slide-toggle>
          </div>
        </div>
      </div>
      <div
        class="attribute-editor-row"
        [shown]="values.type === 'storage-folder'"
      >
        <div class="form-group my-3">
          <span class="flex-row left-right-aligner">
            <label id="shuffle-toggle-label" class="mb-0">Shuffle order</label>
            <mat-slide-toggle
              class="mb-2"
              id="shuffle-toggle"
              aria-labelledby="shuffle-toggle-label"
              [checked]="values.shuffle"
              (change)="toggleShuffle()"
            ></mat-slide-toggle>
          </span>
        </div>
      </div>
      <div
        class="attribute-editor-row"
        [shown]="values.type === 'storage-folder'"
      >
        <div class="form-group my-3">
          <span class="flex-row left-right-aligner">
            <label id="items-to-play-label" class="mb-0"
              >Items to play before moving on</label
            >
            <mat-slide-toggle
              class="mb-2"
              id="items-to-play-toggle"
              aria-labelledby="items-to-play-label"
              [checked]="values.playCountEnabled"
              (change)="togglePlayCountEnabled()"
            ></mat-slide-toggle>
          </span>
          @if (values.playCountEnabled) {
            <div class="input-group mt-2">
              <input
                type="number"
                id="folder-component-items-to-play"
                class="form-control"
                aria-label="Number of items to play"
                [min]="minPlayCount"
                [max]="maxPlayCount"
                [(ngModel)]="values.playCount"
                (change)="savePlayCount()"
              />
              <span class="input-group-addon">Items</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
